import { Card, Icon, IconButton, Stack, Typography, formatFileSize } from '@optimus-web/core';
import { IconName } from '@optimus-web/icons';

export interface ViewFileCardProps {
    fileName: string;
    fileId: string;
    size?: number;
    openFile: ({ id }: { id: string }) => void;
    isPending: boolean;
}

export const ViewFileCard = ({ fileName, fileId, size, openFile, isPending }: ViewFileCardProps) => {
    return (
        <Card padding="200">
            <Stack spacing="200" itemAlignment="center" distribution="space-between">
                <Stack spacing="200" itemAlignment="center">
                    <Icon value={IconName.FiscalReport} />
                    <Stack vertical>
                        <Typography textStyle="bodyMediumStrong" as="div">
                            {fileName}
                        </Typography>
                        {size != null && (
                            <Typography textStyle="bodySmall" as="div" variant="secondary">
                                {formatFileSize(size)}
                            </Typography>
                        )}
                    </Stack>
                </Stack>

                <IconButton
                    variant="tertiary"
                    icon={IconName.Show}
                    size="small"
                    type="button"
                    loading={isPending}
                    onClick={() => openFile({ id: fileId })}
                />
            </Stack>
        </Card>
    );
};
